import { makeOptions } from "@hermes/ui";

export type AuthPageOptions = {
  brandName: string;
  cookieDomain: string;
};

export const { OptionsProvider, useOptions } =
  makeOptions<AuthPageOptions>("AuthPage");
